// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prop-types */
import React from 'react';
import { RegisteredUserContext, OemProfileContext } from '@ekhodealer/ekho-common/components';
import {
	CurrentPaymentIntentContext,
	VehiclesContext,
	UniqueAccessoriesContext,
	AccessoryCountsContext,
	CheckoutCartContext,
	CartHasBoltOns,
	OemVehiclesContext,
	StackedContext,
	OemPickUpLocationsContext,
	PaymentInvoiceContext,
	PaymentInvoiceTotalsContext,
	SelectedPaymentOptionContext,
	SelectedDeliveryOptionContext,
	SelectedRegistrationOptionContext,
	StateDataContext,
	PaymentIntentsContext,
	DiscountsContext,
	OrderIsBeingPlacedContext,
	AbandonedCartIdContext,
	GoogleMapsApiKeyContext,
	AccountDetailsContext,
	CurrentVehicleConfigContext,
	FetchCheckoutContext,
	ActiveModuleContext,
	DeliveryTimeContext,
	RelevantFinancingProgramsContext,
	ShippingAddressSameAsRegistrationAddressContext,
	FetchedServicesProvidersContext,
	SessionContext,
	RegistrationAddressContext,
	SelectedVariantOptionsContext,
	VehicleConfigContext,
	ServicesProvidersContext,
	LooseAccessoriesContext,
	SelectedTradeInOptionContext,
	ModelYearSelectionContext,
	VariantImagesContext,
} from './contexts';
import { PickUpLocationProvider } from './pickUpLocationContext';
import { BuyerInfoProvider } from './buyerInfoContext';

const ContextWrapper = ({
	registeredUserValue,
	oemProfileValue,
	currentPaymentIntentValue,
	vehiclesValue,
	uniqueAccessoriesValue,
	accessoryCountsValue,
	checkoutCartValue,
	children,
	cartHasBoltOns,
	oemVehiclesValue,
	registrationAddressValue,
	stackedValue,
	oemPickUpLocationsValue,
	paymentInvoiceValue,
	paymentInvoiceTotalsValue,
	selectedPaymentOptionValue,
	selectedDeliveryOptionValue,
	selectedRegistrationOptionValue,
	stateDataValue,
	activeDiscountsValue,
	orderIsBeingPlacedValue,
	abandonedCartIdValue,
	googleMapsApiKeyValue,
	selectedVariantOptionsValue,
	accountDetailsValue,
	currentVehicleConfigValue,
	vehicleConfigValue,
	fetchCheckoutValue,
	activeModuleValue,
	deliveryTimeValue,
	relevantFinancingProgramsValue,
	shippingAddressSameAsRegistrationAddressValue,
	looseAccessoriesValue,
	sessionValue,
	servicesProvidersValue,
	fetchedServicesProvidersValue,
	modelYearSelectionProviderValue,
	variantImagesValue,
	selectedTradeInOptionValue,
}) => (
	<RegisteredUserContext.Provider value={registeredUserValue}>
		<OemProfileContext.Provider value={oemProfileValue}>
			<CurrentPaymentIntentContext.Provider value={currentPaymentIntentValue}>
				<VehiclesContext.Provider value={vehiclesValue}>
					<VariantImagesContext.Provider value={variantImagesValue}>
						<SelectedTradeInOptionContext.Provider value={selectedTradeInOptionValue}>
							<ModelYearSelectionContext.Provider
								value={modelYearSelectionProviderValue}>
								<SelectedVariantOptionsContext.Provider
									value={selectedVariantOptionsValue}>
									<UniqueAccessoriesContext.Provider
										value={uniqueAccessoriesValue}>
										<AccessoryCountsContext.Provider
											value={accessoryCountsValue}>
											<CheckoutCartContext.Provider value={checkoutCartValue}>
												<CartHasBoltOns.Provider value={cartHasBoltOns}>
													<OemVehiclesContext.Provider
														value={oemVehiclesValue}>
														<StackedContext.Provider
															value={stackedValue}>
															<OemPickUpLocationsContext.Provider
																value={oemPickUpLocationsValue}>
																<PaymentInvoiceContext.Provider
																	value={paymentInvoiceValue}>
																	<PaymentInvoiceTotalsContext.Provider
																		value={
																			paymentInvoiceTotalsValue
																		}>
																		<SelectedPaymentOptionContext.Provider
																			value={
																				selectedPaymentOptionValue
																			}>
																			<SelectedDeliveryOptionContext.Provider
																				value={
																					selectedDeliveryOptionValue
																				}>
																				<SelectedRegistrationOptionContext.Provider
																					value={
																						selectedRegistrationOptionValue
																					}>
																					<StateDataContext.Provider
																						value={
																							stateDataValue
																						}>
																						<PaymentIntentsContext.Provider
																							value={
																								currentPaymentIntentValue
																							}>
																							<DiscountsContext.Provider
																								value={
																									activeDiscountsValue
																								}>
																								<OrderIsBeingPlacedContext.Provider
																									value={
																										orderIsBeingPlacedValue
																									}>
																									<RegistrationAddressContext.Provider
																										value={
																											registrationAddressValue
																										}>
																										<AbandonedCartIdContext.Provider
																											value={
																												abandonedCartIdValue
																											}>
																											<GoogleMapsApiKeyContext.Provider
																												value={
																													googleMapsApiKeyValue
																												}>
																												<AccountDetailsContext.Provider
																													value={
																														accountDetailsValue
																													}>
																													<VehicleConfigContext.Provider
																														value={
																															vehicleConfigValue
																														}>
																														<CurrentVehicleConfigContext.Provider
																															value={
																																currentVehicleConfigValue
																															}>
																															<FetchCheckoutContext.Provider
																																value={
																																	fetchCheckoutValue
																																}>
																																<ActiveModuleContext.Provider
																																	value={
																																		activeModuleValue
																																	}>
																																	<DeliveryTimeContext.Provider
																																		value={
																																			deliveryTimeValue
																																		}>
																																		<LooseAccessoriesContext.Provider
																																			value={
																																				looseAccessoriesValue
																																			}>
																																			<FetchedServicesProvidersContext.Provider
																																				value={
																																					fetchedServicesProvidersValue
																																				}>
																																				<SessionContext.Provider
																																					value={
																																						sessionValue
																																					}>
																																					<ServicesProvidersContext.Provider
																																						value={
																																							servicesProvidersValue
																																						}>
																																						<ShippingAddressSameAsRegistrationAddressContext.Provider
																																							value={
																																								shippingAddressSameAsRegistrationAddressValue
																																							}>
																																							<RelevantFinancingProgramsContext.Provider
																																								value={
																																									relevantFinancingProgramsValue
																																								}>
																																								<BuyerInfoProvider>
																																									<PickUpLocationProvider>
																																										{
																																											children
																																										}
																																									</PickUpLocationProvider>
																																								</BuyerInfoProvider>
																																							</RelevantFinancingProgramsContext.Provider>
																																						</ShippingAddressSameAsRegistrationAddressContext.Provider>
																																					</ServicesProvidersContext.Provider>
																																				</SessionContext.Provider>
																																			</FetchedServicesProvidersContext.Provider>
																																		</LooseAccessoriesContext.Provider>
																																	</DeliveryTimeContext.Provider>
																																</ActiveModuleContext.Provider>
																															</FetchCheckoutContext.Provider>
																														</CurrentVehicleConfigContext.Provider>
																													</VehicleConfigContext.Provider>
																												</AccountDetailsContext.Provider>
																											</GoogleMapsApiKeyContext.Provider>
																										</AbandonedCartIdContext.Provider>
																									</RegistrationAddressContext.Provider>
																								</OrderIsBeingPlacedContext.Provider>
																							</DiscountsContext.Provider>
																						</PaymentIntentsContext.Provider>
																					</StateDataContext.Provider>
																				</SelectedRegistrationOptionContext.Provider>
																			</SelectedDeliveryOptionContext.Provider>
																		</SelectedPaymentOptionContext.Provider>
																	</PaymentInvoiceTotalsContext.Provider>
																</PaymentInvoiceContext.Provider>
															</OemPickUpLocationsContext.Provider>
														</StackedContext.Provider>
													</OemVehiclesContext.Provider>
												</CartHasBoltOns.Provider>
											</CheckoutCartContext.Provider>
										</AccessoryCountsContext.Provider>
									</UniqueAccessoriesContext.Provider>
								</SelectedVariantOptionsContext.Provider>
							</ModelYearSelectionContext.Provider>
						</SelectedTradeInOptionContext.Provider>
					</VariantImagesContext.Provider>
				</VehiclesContext.Provider>
			</CurrentPaymentIntentContext.Provider>
		</OemProfileContext.Provider>
	</RegisteredUserContext.Provider>
);

export default ContextWrapper;
